import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { Base2Service } from '../base2.service';
import { ToolsService } from '../../tools/tools.service';
import { BaseclientService } from '../../apiclient/baseclient.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ClientMerchantsService } from '../../apiclient/clientmerchants/clientmerchants.service';
import { cloneDeep, forEach } from 'lodash';
import { LangagesService } from '../../manage/langages/langages.service';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class ProdcatService {

  constructor(
    private base2: Base2Service,
    private tools: ToolsService,
    private base: BaseclientService,
    private authService: AuthService,
    private clientMerchantApi: ClientMerchantsService,
    private langServ: LangagesService
  ) { }

  getProdCats(): Observable<any> {
    const pointOfSale = this.tools.getStor("point_of_sale");
    const params = { for_sale: 1, id_point_of_sale: pointOfSale.id, new_version: 1 };


    return from(this.base2.getBase("product_categories", params)).pipe(
      map(cats => cats.list)
    )
  }

  getApiProdCats(): Observable<any> {

    const params = {};
    return from(this.base.postBaseApi("products_categories", params)).pipe(
      map(cats => cats.products_categories.list)
    )
  }






  getTotal(price: any, quantity: any) {
    const total = price * quantity;
    return (Math.round(total * 100) / 100);
  }



  getPeriodDay() {
    const now = moment();
    const dateOrder = this.tools.getStor("date_order") ? moment(this.tools.getStor("date_order")) : now;
    const hourOrder = this.tools.getStor("hour_order") ? moment(this.tools.getStor("hour_order")) : now;

    return dateOrder.format("YYYY-MM-DD") + ' ' + hourOrder.format("HH:mm:ss");




  }


  getApiProdCatsByIdProd(prod: any): Observable<any> {
 

    const lang = this.langServ.getLang();


    const params = {
      prod_id: prod.id,
      language: lang,
      price_period_date:this.getPeriodDay()
    };

    return from(this.base.postBaseApi("products_categories_by_prod_id", params)).pipe(
      map((cats: any) => {
      

        //product with option
        if (prod.product_type < 2) {
          if (cats.product_categories.list && cats.product_categories.list.length > 0) {
            cats.product_categories.list.forEach((element: any) => {
              if (element.details && element.details.length > 0) {
                element.details.forEach((detail: any) => {
                  detail.product.rubric = prod.rubric;
                })
              }

            });
          }

        }


        return cats.product_categories.list
      })
    )
  }



  getApiProdCatsByIdProds(prods: any): Observable<any> {


    let arrayIdsProducts: any = [];
    if (prods && prods.length > 0)
      prods.forEach((element: any) => {
        if (element.product_type > 0) {
          arrayIdsProducts.push(element.id);
        }
      });
    const lang = this.langServ.getLang();

    const params = {
      ids_products: arrayIdsProducts
      , language: lang
    };

    return from(this.base.postBaseApi("products_categories_array_prods_ids", params)).pipe(
      map(cats => cats.products_categories.list)
    )
  }


  getProductCategoryByProdIds(prods: any): Observable<any> {
    

    let arrayIdsProducts: any = [];
    if (prods && prods.length > 0)
      prods.forEach((element: any) => {
        if (element.product_type > 0) {
          arrayIdsProducts.push(element.id);
        }
      });


    const params = { ids_products: arrayIdsProducts };


    return from(this.base.postBaseApi("products_categories_prods_ids", params)).pipe(
      map(cats => cats.products_categories.list)
    )
  }









}
